<template>
  <div class="card" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
    <div class="content">
      <p class="title">{{ title }}</p>
      <p class="description" :style="{ color: descriptionColor }">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backgroundImage: String,
    title: String,
    description: String,
    descriptionColor: {
      type: String,
      default: '#696d83' // 设置默认描述颜色
    }
  }
}
</script>

<style scoped lang="less">
.card {
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 40px;
  overflow: hidden;
  }

  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #262626;
    line-height: 40px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    // font-size: 28px;
    // font-family: 'PingFang SC-Medium', sans-serif;
    // color: #262626;
    margin: 0;
    padding: 0;
    /* white-space: nowrap; */
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    /* 确保长单词也会换行 */
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .description {
    margin-top: 12px;
    margin-bottom: 0;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400; 
    line-height: 36px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    color: #696d83;
    padding: 0;
    white-space: pre-wrap;
    /* 允许自动换行 */
    overflow-wrap: break-word;
    /* 确保长单词也会换行 */
    display: -webkit-box;
    -webkit-line-clamp: 9;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* 移动端适配 */
.mobile {
  .card {
  padding: 16px;

  }

  .content {
    margin-left: 0px;
    margin-top: 0px;
  }

  .title {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #262626;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .description {
    margin-top: 6px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #677E79;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
